<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>偷功能</span>
      </div>

      <el-form>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>基本配置</span>
              </div>
              <el-form :inline="true">
                <el-form-item label="偷取比例(%)">
                  <el-input v-model.number="basic.rate" placeholder="偷取比例" />
                </el-form-item>
                <el-form-item label="每个机器人偷睡眠时长(秒)">
                  <el-input v-model.number="basic.sleep" placeholder="偷睡眠时长(秒)" />
                </el-form-item>
                <el-form-item label="每个好友最大偷取次数(天)">
                  <el-input v-model.number="basic.num" placeholder="每个好友最大偷取次数(天)" />
                </el-form-item>
                <el-form-item label="单个好友偷取冷却时间(秒)">
                  <el-input v-model.number="basic.coolDown" placeholder="单个好友偷取冷却时间(秒)" />
                </el-form-item>
              </el-form>
            </el-card>
          </el-col>
        </el-row>
        <el-button class="mtop" type="primary" @click="onSubmit()">保存</el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { getCommonCfg, updateCommonCfg } from '@/api/config/common-cfg'

export default {
  name: 'RobotSlot',
  data() {
    return {
      key: 'ROBOT_FRIEND_CONFIG:STEAL',
      basic: {
        rate: 10,
        sleep: 300,
        num: 2,
        coolDown: 300
      }
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    getTables() {
      getCommonCfg({ name: this.key }).then(res => {
        this.basic = res.data
      })
    },
    onSubmit() {
      const data = JSON.stringify(this.basic)
      updateCommonCfg({ data: data, name: this.key }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
.mtop{
  margin-top: 20px;
}
</style>
